import React from 'react';
import { IonButton, IonContent, IonHeader, IonModal, IonTitle, IonToolbar, IonButtons, IonIcon, IonCard, IonCardHeader, IonCardContent, IonAvatar, IonCardTitle, IonCardSubtitle, IonGrid, IonRow, IonCol } from '@ionic/react';
import { close, personCircle } from 'ionicons/icons';

interface ScannedBadgeProps {
  isOpen: boolean;
  onClose: () => void;
  scannedData: string;
}

const ScannedBadge: React.FC<ScannedBadgeProps> = ({ isOpen, onClose, scannedData }) => {
  // Parsear los datos escaneados
  // Intentamos varios formatos posibles para mayor compatibilidad
  const parseScannedData = () => {
    try {
      // Si es un código QR de nuestro sistema (formato: "nombre&&&empresa&&&tipo")
      if (scannedData.includes('&&&')) {
        const parts = scannedData.split('&&&');
        return {
          name: parts[0] || 'Nombre no disponible',
          company: parts[1] || 'Empresa no disponible',
          type: parts[2] || 'Tipo no disponible'
        };
      }

      // Si es un posible JSON
      if (scannedData.startsWith('{') && scannedData.endsWith('}')) {
        try {
          const jsonData = JSON.parse(scannedData);
          return {
            name: jsonData.name || jsonData.nombre || 'Nombre no disponible',
            company: jsonData.company || jsonData.empresa || 'Empresa no disponible',
            type: jsonData.type || jsonData.tipo || 'Tipo no disponible'
          };
        } catch (e) {
          // No es un JSON válido, continuamos con otros formatos
        }
      }

      // Si es una URL o texto simple
      return {
        name: 'Datos escaneados',
        company: 'Contenido del QR',
        type: scannedData.length > 30 ? scannedData.substring(0, 30) + '...' : scannedData
      };
    } catch (error) {
      console.error('Error parsing QR data:', error);
      return {
        name: 'Error al leer datos',
        company: 'Formato no reconocido',
        type: 'Contenido: ' + (scannedData.length > 20 ? scannedData.substring(0, 20) + '...' : scannedData)
      };
    }
  };

  const badgeData = parseScannedData();

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="scanned-badge-modal">
      <IonHeader>
        <IonToolbar className="gradient-bg-primary">
          <IonTitle className="ion-text-center" style={{ color: 'white' }}>Gafete Escaneado</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon icon={close} style={{ color: 'white' }} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="bg-glass">
        <div className="ion-padding">
          <IonCard className="ticket-card glass-effect ion-text-center">
            <IonCardHeader className="ion-text-center">
              <IonAvatar className="profile-avatar" style={{ margin: '0 auto', padding: '15px' }}>
                <IonIcon icon={personCircle} style={{ fontSize: '80px', color: 'var(--app-primary-color)' }} />
              </IonAvatar>
              <IonCardTitle className="attendee-name text-primary">{badgeData.name}</IonCardTitle>
              <IonCardSubtitle className="company-name">{badgeData.company}</IonCardSubtitle>
            </IonCardHeader>

            <IonCardContent>
              <IonGrid>
                <IonRow className="ion-justify-content-center ion-align-items-center">
                  <IonCol size="12" className="ion-text-center">
                    <div className="gradient-bg-primary ion-padding" style={{ borderRadius: 'var(--glass-border-radius)' }}>
                      {badgeData.type}
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>

              <IonButton expand="block" className="button-gradient ion-margin-top" onClick={onClose}>
                Cerrar
              </IonButton>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default ScannedBadge;
